import { IApplicationState } from '../types/redux';
import { INewbuildingsPlusBlocksPikContract } from '../repositories/special-promos-custom/entities/ContentBlocks/NewbuildingsPlusBlocksPikContract';

/**
 * Обновляет состояние - добавляет данные о ПИК+ для ЖК
 */
export function mergePikPlusDataToInitialState(
  initialState: IApplicationState,
  response: INewbuildingsPlusBlocksPikContract[],
) {
  response.forEach(item => {
    const residential = initialState.residentialComplexes.hash[item.newbuildingId];
    if (residential) {
      residential.displayType = 'plus';
      residential.description = item.description;
      residential.equipmentOptions = item.equipmentOptions.map(equipment => {
        return {
          imageUrl: equipment.image,
          title: equipment.title,
        };
      });
    }
  });
}
